// extracted by mini-css-extract-plugin
export default {"textFormInput":"input-form-text_textFormInput__XPuTC","error":"input-form-text_error__ABEEY"};